import { defineComponent as _defineComponent } from 'vue'
import type { RmSurveyDialogContent } from '@/utils/realtime-transfer/rmSurvey'


export default /*#__PURE__*/_defineComponent({
  __name: 'RmSurveyCompleted',
  props: {
    content: null
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({ (e: 'close'): void }), expose: any, slots: any, attrs: any }) {




return { __sfc: true,emit }
}

})